export default __webpack_public_path__ + "static/media/v005.366a0801.mp4";